import React from 'react';

// Components
import { CancelButton, PrimaryButton } from '../buttons';

// Utils
import { formatMessage } from '../../../utils/i18n';
import ModalV2 from './ModalV2';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  showModal: boolean;
};

const SharedWithClientModal: React.FC<Props> = ({ onCancel, showModal, onConfirm }) => (
  <ModalV2
    show={showModal}
    title={formatMessage('ComparisonsTableV2.SharedWithClientModal.Title')}
    body={formatMessage('ComparisonsTableV2.SharedWithClientModal.Body')}
    modalClassName="body-md shared-with-client-modal"
    onClose={onCancel}
    footer={
      <>
        <CancelButton onClick={onCancel} />
        <PrimaryButton onClick={onConfirm}>{formatMessage('ComparisonsTableV2.SharedWithClientModal.Actions.MarkShared')}</PrimaryButton>
      </>
    }
  />
);

export default SharedWithClientModal;
